import { Outlet, ScrollRestoration } from 'react-router-dom';
import { Toaster } from 'sonner';
import { Navbar } from '@/components/Navbar';
import { Footer } from '@/components/Footer';

export function RootLayout() {
  return (
    <div className="flex min-h-screen flex-col bg-eol-bg text-eol-white">
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <Toaster
        position="top-right"
        theme="dark"
        toastOptions={{
          style: { background: '#0E0E0E', border: '1px solid rgba(255,255,255,0.07)' },
        }}
      />
      <ScrollRestoration />
    </div>
  );
}
